import { DEFAULT_LOCALE, getLocalDate } from '@skytech/utils'

import { useAppContext } from '@/app/index.context'

export const useLocalDate = () => {
  const { locale } = useAppContext()

  const formatDate = ({ date }: { date: string | Date | null }) => {
    if (!date) return ''

    return getLocalDate({
      date,
      locale: locale || DEFAULT_LOCALE,
    })
  }

  return { formatDate }
}
